import { useNavigate } from 'react-router-dom';
import nawatechLogo from '../assets/nawatech-logo.png';
import desktopIcon from '../assets/desktopIcon.svg';
import './Homepage.css';
import { useDispatch } from 'react-redux';
import { logout } from '../libs/redux/slices/authSlice';
import useDocumentTitle from '../hooks/useDocumentTitle';
import { useSelector } from 'react-redux';

const Homepage = () => {
  useDocumentTitle('Home');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.auth.user);

  const handleLogout = async () => {
    sessionStorage.clear();
    localStorage.clear();
    dispatch(logout());
    // window.location.href = "https://sts.sinarmas-agri.com/adfs/ls/?wa=wsignout1.0";
  };

  const handleClick = (params) => {
    navigate(`/dashboard/${params}`);
  };

  return (
    <div className="homepage">
      <div className="banner">
        <img style={{width:"12rem"}} src={nawatechLogo} alt="Img" />
        <button className="logout-button" onClick={handleLogout}>Logout</button>
      </div>
      <hr className="separator-line" />
      <div className="homepage-container">
        {user.dashboard.map((dashboard, index) => (
          <div key={index} className="box" onClick={() => handleClick(dashboard.slug)}>
            <div className='box-title'>{dashboard.dashboard_name}</div>
            <img src={desktopIcon} alt="Desktop Icon" className="desktop-icon" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Homepage;